import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Twitter: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <g clipPath='url(#clip0_10200_102)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.5753 4.85999L13.4106 8.37683L10.8273 4.93242L8.24411 1.48801H4.50349C1.28344 1.48801 0.764701 1.49274 0.775933 1.52207C0.783133 1.54079 2.69913 4.1031 5.0337 7.21607C7.36828 10.329 9.2859 12.8884 9.29507 12.9035C9.30508 12.92 7.82288 14.586 5.60116 17.0555C3.56032 19.324 1.85879 21.2135 1.81996 21.2545L1.74935 21.329L2.48684 21.9925C2.89247 22.3574 3.23219 22.656 3.24176 22.656C3.25134 22.656 4.89779 20.8354 6.90052 18.6101C8.90327 16.3849 10.55 14.5732 10.5598 14.5841C10.5698 14.5951 11.908 16.3784 13.5338 18.5471C15.1596 20.7158 16.5029 22.4952 16.5189 22.5013C16.5349 22.5074 18.2254 22.5096 20.2755 22.5062L24.003 22.5L19.3776 16.332C16.8336 12.9396 14.7264 10.13 14.6951 10.0884L14.638 10.0128L17.939 6.34508C19.7546 4.32781 21.2392 2.67162 21.2382 2.66466C21.2353 2.64402 19.7939 1.35659 19.7658 1.34955C19.7516 1.34603 18.3159 2.92571 16.5753 4.85999ZM4.77601 3.51603C4.77601 3.52263 7.63936 7.34583 11.139 12.012L17.502 20.496H18.747H19.9921L13.62 12L7.24796 3.50401H6.01199C5.33219 3.50401 4.77601 3.50941 4.77601 3.51603Z'
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_10200_102'>
        <rect
          width='24'
          height='24'
          fill={fill}
        />
      </clipPath>
    </defs>
  </svg>
)

export default Twitter
